<template>
	<div class="container pb_0">
		<div class="sub_top">
			<div class="top_content">
				<div class="headline">
					<p class="sub_title">
						{{ $t('rtr_personal-how-trade_and_cashback.title1') }}<br />
						{{ $t('rtr_personal-how-trade_and_cashback.title2') }}
					</p>
					<p class="sub_text">
						{{ $t('rtr_personal-how-trade_and_cashback.text1') }}<br />
						{{ $t('rtr_personal-how-trade_and_cashback.text2') }}<br />
						{{ $t('rtr_personal-how-trade_and_cashback.text3') }}
					</p>

					<div class="button_area">
						<button
							class="button_bg_red mr_10"
							@click="$router.push({ name: 'auth-register' })"
						>
							{{ $t('button.signup') }}
						</button>
						<button class="button_bg_black" @click="notYet">
							{{ $t('button.down') }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<section>
			<div class="sub_content1">
				<div class="sub_content">
					<div class="detail_area_center">
						<div>
							<h2 class="title">
								{{ $t('rtr_personal-how-trade_and_cashback.title3') }}
							</h2>
							<p class="text">
								{{ $t('rtr_personal-how-trade_and_cashback.text4') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text5') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text6') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="img_area">
						<img src="@/assets/images/sub/trade_and_cashback_03.png" alt="" />
					</div>
					<div class="detail_area">
						<div class="detail">
							<h2 class="title">
								{{ $t('rtr_personal-how-trade_and_cashback.title4') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.title5') }}
							</h2>
							<p class="text mb_50">
								{{ $t('rtr_personal-how-trade_and_cashback.text7') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text8') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text9') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text10') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text11') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text12') }}
							</p>
							<router-link to class="link_type_02" @click="notYet">
								{{ $t('rtr_personal-how-trade_and_cashback.text13') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section>
			<div class="sub_content">
				<div class="d_flex">
					<div class="detail_area">
						<div class="detail type_02">
							<h2 class="title">
								{{ $t('rtr_personal-how-trade_and_cashback.title6') }}
							</h2>
							<p class="text mb_50">
								{{ $t('rtr_personal-how-trade_and_cashback.text14') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text15') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text16') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text17') }}<br />
							</p>
							<router-link to class="link_type_02" @click="notYet">
								{{ $t('rtr_personal-how-trade_and_cashback.text18') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
					<div class="img_area">
						<img src="@/assets/images/sub/trade_and_cashback_04.png" alt="" />
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	name: 'TradeAndCashback',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
